import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_3 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_4 = { class: "symbol-label bg-light" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_6 = { class: "timeline-content mb-10 mt-n2" }
const _hoisted_7 = { class: "overflow-auto pe-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold mb-2" }, " Invitation for crafting engaging designs that speak human workshop ", -1)
const _hoisted_9 = { class: "d-flex align-items-center mt-1 fs-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted me-2 fs-7" }, "Sent at 4:23 PM by", -1)
const _hoisted_11 = {
  class: "symbol symbol-circle symbol-25px",
  "data-bs-toggle": "tooltip",
  "data-bs-boundary": "window",
  "data-bs-placement": "top",
  title: "Alan Nilson"
}
const _hoisted_12 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, {
            src: "/media/icons/duotune/communication/com009.svg",
            "aria-hidden": "true"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: "/media/avatars/150-2.jpg",
              alt: _ctx.translate('FACE_OF_A_PERSON')
            }, null, 8, _hoisted_12)
          ])
        ])
      ])
    ])
  ]))
}